<template>
  <div class="big integralExchange">
    <div class="page_title">积分兑换</div>
    <div style="padding: 20px; border-radius: 5px">
      <div class="container"
           style="padding: 10px 20px 20px 20px;">

        <div class="top-header">
          <div class="search-box">
            <!-- 优惠券名称 -->
            <div class="item">
              <span>优惠券名称</span>
              <div class="item-content">
                <el-input v-model="searchForm.coupon_name"
                          size="small"
                          clearable
                          @keyup.enter.native="seachEnterFun"
                          placeholder="请输入"></el-input>
              </div>
            </div>

            <!-- 优惠券类型 -->
            <div class="item">
              <span style="margin-left:10px">优惠券类型</span>
              <div class="item-content">
                <el-select v-model="searchForm.coupon_from"
                           size="small"
                           placeholder="请选择"
                           @change="seachEnterFun">
                  <el-option v-for="item in couponFromOptions"
                             :key="item.value"
                             :label="item.label"
                             :value="item.value">
                  </el-option>
                </el-select>
              </div>
              <el-button type="primary"
                         size="small"
                         style="margin-left:20px"
                         @click="getList">查询</el-button>
              <el-button size="small"
                         @click="restBtn">重置</el-button>
            </div>
          </div>
          <!-- 新增活动 -->
          <div style="margin-bottom: 10px;">
            <el-button type="primary"
                       size="medium"
                       :disabled="module_id_array[0]?!module_id_array.includes('1594'):false"
                       @click="addBtn">添加兑换</el-button>
          </div>
        </div>
        <div style="border: solid 1px #c9cbd6;">
          <el-table v-loading="tableLoading"
                    :data="integralExchangeData"
                    tooltip-effect="dark"
                    style="width: 100%; min-width: 1000px"
                    :header-cell-style="{ background: '#F5F5F5' }">
            <el-table-column v-for="item in tableHeader"
                             :key="item.prop"
                             :prop="item.prop"
                             :label="item.label"
                             :width="item.width"
                             :fixed="item.fixed">
              <template slot-scope="scope">
                <div v-if="item.prop == 'coupon_from'">
                  {{ scope.row[item.prop] | couponFromText }}
                </div>
                <div v-else-if="item.prop == 'message'">
                  {{ scope.row.use_condition }}
                </div>

                <div v-else-if="item.prop == 'use_time'">
                  <div v-if="scope.row['time_limit'] == 2">
                    {{ scope.row['time_start'] | dateFormat }} -
                    {{ scope.row['time_end'] | dateFormat }}
                  </div>
                  <div v-else>
                    领取后{{ scope.row['time_days'] }}有效
                  </div>
                </div>

                <div v-else-if="item.prop == 'show_time'">
                  {{ scope.row['show_start_time'] | dateFormat }} -
                  {{ scope.row['show_end_time'] | dateFormat }}
                </div>

                <div v-else-if="item.prop == 'total'">
                  {{ scope.row[item.prop] | totalText }}
                </div>

                <div v-else>
                  {{  scope.row[item.prop] }}
                </div>
              </template>
            </el-table-column>

            <el-table-column label="排序"
                             align="center"
                             width="160">
              <template slot-scope="scope">
                <el-tooltip class="item"
                            effect="dark"
                            content="置顶"
                            placement="top">
                  <el-button @click="updateSort(scope.row.rule_id, 1)"
                             size="medium"
                             type="text"
                             icon="el-icon-upload2"
                             :disabled="module_id_array[0] ? !module_id_array.includes('1595'): false "
                             style="font-size: 20px"></el-button>
                </el-tooltip>

                <el-tooltip class="item"
                            effect="dark"
                            content="置底"
                            placement="top">
                  <el-button @click="updateSort(scope.row.rule_id, 2)"
                             size="medium"
                             type="text"
                             icon="el-icon-download"
                             :disabled="module_id_array[0] ? !module_id_array.includes('1595') : false"
                             style="font-size: 20px"></el-button>
                </el-tooltip>

                <el-tooltip class="item"
                            effect="dark"
                            content="上移"
                            placement="top">
                  <el-button @click="updateSort(scope.row.rule_id, 3)"
                             size="medium"
                             type="text"
                             icon="el-icon-top"
                             :disabled="module_id_array[0] ? !module_id_array.includes('1595') : false "
                             style="font-size: 20px"></el-button>
                </el-tooltip>

                <el-tooltip class="item"
                            effect="dark"
                            content="下移"
                            placement="top">
                  <el-button @click="updateSort(scope.row.rule_id, 4)"
                             size="medium"
                             type="text"
                             icon="el-icon-bottom"
                             :disabled="module_id_array[0] ? !module_id_array.includes('1595') : false"
                             style="font-size: 20px"></el-button>
                </el-tooltip>
              </template>
            </el-table-column>
            <el-table-column label="操作"
                             width="220"
                             align="center"
                             fixed="right">
              <template slot-scope="scope">
                <el-button type="text"
                           size="medium"
                           @click="delBtn(scope.row.rule_id)"
                           :disabled="module_id_array[0]?!module_id_array.includes('1593'):false">删除</el-button>

              </template>
            </el-table-column>
          </el-table>
        </div>
        <!-- 分页 -->
        <pagination v-show="totalNum>0"
                    :total="totalNum"
                    :page.sync="pagination.page"
                    :limit.sync="pagination.pageNumber"
                    @pagination="getList" />
      </div>
    </div>
    <!-- 选择优惠券 -->
    <el-dialog title="选择优惠券"
               width="1000px"
               custom-class="dia-coupon"
               ref="diaCouponTable"
               :visible.sync="couponDia"
               :before-close="closeCoupon"
               :close-on-click-modal="false"
               :close-on-press-escape='false'>
      <div style="padding:10px 20px">
        <div class="search_box">
          <div class="item">
            <span>优惠券名称</span>
            <el-input v-model="couponDiaForm.coupon_name"
                      size="medium"
                      clearable
                      @change="seachEnterFun"
                      placeholder="优惠券名称"
                      class="input_width"></el-input>
          </div>

          <div class="item">
            <span>优惠券分类</span>
            <el-select v-model="couponDiaForm.coupon_from"
                       size="medium"
                       placeholder="优惠券分类"
                       class="input_width"
                       @change="couponFromChange">
              <el-option label="诊疗优惠劵"
                         :value="1"></el-option>
              <el-option label="商城优惠券"
                         :value="2"></el-option>
            </el-select>
          </div>

          <div style="width:100px">
            <el-button type="primary"
                       size="medium"
                       style="margin-left:20px"
                       @click="getClickOrShopCoupon">查询</el-button>
          </div>

        </div>
        <div style="border:1px solid #f5f5f5">
          <template v-if="couponDiaForm.coupon_from == 1">
            <el-table v-loading="couponDiaTableLoading"
                      :data="couponTableDiaData"
                      tooltip-effect="dark"
                      height="400px"
                      :header-cell-style="{ background: '#F5F5F5' }"
                      @selection-change="handleDiaSelectionChange">
              <el-table-column type="selection"
                               width="50">
              </el-table-column>
              <el-table-column v-for="item in couponTableDiaHeader"
                               :key="item.prop"
                               :prop="item.prop"
                               :label="item.label"
                               :width="item.width"
                               :fixed="item.fixed">
                <template slot-scope="scope">
                  <div v-if="item.prop == 'coupon_from'">
                    {{ scope.row[item.prop] | couponFromText }}
                  </div>
                  <div v-else-if="item.prop == 'message'">
                    {{  scope.row.use_condition }}
                  </div>

                  <div v-else-if="item.prop == 'use_time'">
                    <div v-if="scope.row['time_limit'] == 2">
                      {{ scope.row['time_start'] | dateFormat }} -
                      {{ scope.row['time_end'] | dateFormat }}
                    </div>
                    <div v-else>
                      领取后{{ scope.row['time_days'] }}有效
                    </div>
                  </div>

                  <div v-else-if="item.prop == 'show_time'">
                    {{ scope.row['show_start_time'] | dateFormat }} -
                    {{ scope.row['show_end_time'] | dateFormat }}
                  </div>

                  <div v-else-if="item.prop == 'total'">
                    {{ scope.row[item.prop] | totalText }}
                  </div>
                  <div v-else>
                    {{  scope.row[item.prop] }}
                  </div>
                </template>
              </el-table-column>
            </el-table>
          </template>
          <template v-else>
            <el-table v-loading="couponDiaTableLoading"
                      :data="couponTableDiaData"
                      tooltip-effect="dark"
                      height="400px"
                      :header-cell-style="{ background: '#F5F5F5' }"
                      @selection-change="handleDiaSelectionChange2">
              <el-table-column type="selection"
                               width="50">
              </el-table-column>
              <el-table-column v-for="item in couponTableDiaHeader"
                               :key="item.prop"
                               :prop="item.prop"
                               :label="item.label"
                               :width="item.width"
                               :fixed="item.fixed">
                <template slot-scope="scope">
                  <div v-if="item.prop == 'coupon_from'">
                    {{ scope.row[item.prop] | couponFromText }}
                  </div>
                  <div v-else-if="item.prop == 'message'">
                    {{  scope.row.use_condition }}
                  </div>

                  <div v-else-if="item.prop == 'use_time'">
                    <div v-if="scope.row['time_limit'] == 2">
                      {{ scope.row['time_start'] | dateFormat }} -
                      {{ scope.row['time_end'] | dateFormat }}
                    </div>
                    <div v-else>
                      领取后{{ scope.row['time_days'] }}有效
                    </div>
                  </div>

                  <div v-else-if="item.prop == 'show_time'">
                    {{ scope.row['show_start_time'] | dateFormat }} -
                    {{ scope.row['show_end_time'] | dateFormat }}
                  </div>

                  <div v-else-if="item.prop == 'total'">
                    {{ scope.row[item.prop] | totalText }}
                  </div>
                  <div v-else>
                    {{  scope.row[item.prop] }}
                  </div>
                </template>
              </el-table-column>
            </el-table>
          </template>

        </div>
        <div class="between align-center">
          <!-- 分页 -->
          <pagination v-show="couponDiaTotalNum>0"
                      :total="couponDiaTotalNum"
                      :page.sync="couponDiaPagination.page"
                      :limit.sync="couponDiaPagination.pageNumber"
                      @pagination="getClickOrShopCoupon" />
          <div style="padding: 10px 20px 0 0 ">
            <el-button size="medium"
                       @click="closeCoupon">取 消</el-button>
            <el-button size="medium"
                       type="primary"
                       @click="confirmCoupon">确 定</el-button>
          </div>

        </div>
      </div>
    </el-dialog>
    <!-- 设置兑换积分数 -->
    <el-dialog title="设置兑换积分数"
               width="1000px"
               ref="diaTable"
               custom-class="dia-coupon"
               :visible.sync="setIntegralDia"
               :before-close="closeSet"
               :close-on-click-modal="false"
               :close-on-press-escape='false'>
      <div style="padding:10px 20px">
        <div style="border:1px solid #f5f5f5">
          <el-table :data="setIntegralDiaData"
                    tooltip-effect="dark"
                    height="400px"
                    :header-cell-style="{ background: '#F5F5F5' }">
            <el-table-column v-for="item in setIntegralDiaHeader"
                             :key="item.prop"
                             :prop="item.prop"
                             :label="item.label"
                             :width="item.width"
                             :fixed="item.fixed">
              <template slot-scope="scope">
                <div v-if="item.prop == 'coupon_from'">
                  {{ scope.row[item.prop] | couponFromText }}
                </div>
                <div v-else-if="item.prop == 'message'">
                  {{   scope.row.use_condition }}
                </div>
                <div v-else>
                  {{  scope.row[item.prop] }}
                </div>
              </template>
            </el-table-column>
            <el-table-column label="兑换积分数"
                             width="220"
                             align="center"
                             fixed="right">
              <template slot-scope="scope">
                <el-input-number v-model="scope.row.integral"
                                 size="small"
                                 :min="1"
                                 :max="999999999"
                                 :precision="0"
                                 :controls="false"
                                 placeholder="请输入"
                                 @blur="setIntegralBlur(scope.row)"></el-input-number>

              </template>
            </el-table-column>
          </el-table>
        </div>
        <div class="between align-center">
          <div style="padding: 10px 20px 0 0 ">
            <el-button size="medium"
                       @click="closesetIntegral">取 消</el-button>
            <el-button size="medium"
                       type="primary"
                       @click="confirmsetIntegral">确 定</el-button>
          </div>

        </div>
      </div>
    </el-dialog>
  </div>

</template>

<script>
import _ from 'lodash';
import dayjs from 'dayjs';
import integralmanage from '@/api/integralmanage.js';
import Pagination from '@/components/Pagination/index';
import common from '../../../api/common';
export default {
  components: {
    Pagination
  },
  data() {
    return {
      totalNum: 0,
      pagination: {
        page: 1,
        pageNumber: 10
      },
      couponFromOptions: [
        {
          value: 0,
          label: '全部'
        },
        {
          value: 1,
          label: '诊疗优惠劵'
        },
        {
          value: 2,
          label: '商城优惠券'
        }
      ],
      searchForm: {
        coupon_name: '',
        coupon_from: 0
      },
      tableHeader: [
        {
          label: '优惠券名称',
          prop: 'coupon_name',
          width: 'auto',
          align: 'center',
          fixed: 'left'
        },
        {
          label: '优惠券分类',
          prop: 'coupon_from',
          width: '140',
          align: 'center',
          fixed: false
        },
        {
          label: '使用条件',
          prop: 'message',
          width: '200',
          align: 'center',
          fixed: false
        },
        {
          label: '使用时间',
          prop: 'use_time',
          width: '200',
          align: 'center',
          fixed: false
        },
        {
          label: '领取时间',
          prop: 'show_time',
          width: '200',
          align: 'center',
          fixed: false
        },
        {
          label: '发放总数',
          prop: 'total',
          width: 'auto',
          align: 'center',
          fixed: false
        },
        {
          label: '已兑换次数',
          prop: 'exchange_num',
          width: 'auto',
          align: 'center',
          fixed: false
        },
        {
          label: '兑换积分数',
          prop: 'integral',
          width: 'auto',
          align: 'center',
          fixed: false
        }
      ],
      integralExchangeData: [],
      // 选择优惠券
      couponDia: false,
      couponDiaTotalNum: 0,
      couponDiaPagination: {
        page: 1,
        pageNumber: 10
      },
      couponDiaForm: {
        coupon_name: '',
        coupon_from: 1
      },
      couponDiaTableLoading: false,
      couponTableDiaData: [],
      couponTableDiaHeader: [
        {
          label: '优惠券名称',
          prop: 'coupon_name',
          width: '160',
          align: 'center',
          fixed: false
        },
        {
          label: '优惠券分类',
          prop: 'coupon_from',
          width: 'auto',
          align: 'center',
          fixed: false
        },
        {
          label: '使用条件',
          prop: 'message',
          width: '200',
          align: 'center',
          fixed: false
        },
        {
          label: '发放总数',
          prop: 'total',
          width: '80',
          align: 'center',
          fixed: false
        },
        {
          label: '使用时间',
          prop: 'use_time',
          width: 'auto',
          align: 'center',
          fixed: false
        },
        {
          label: '领取时间',
          prop: 'show_time',
          width: 'auto',
          align: 'center',
          fixed: false
        }
      ],
      // 设置兑换积分
      setIntegralDia: false,
      setIntegralDiaHeader: [
        {
          label: '优惠券名称',
          prop: 'coupon_name',
          width: '160',
          align: 'center',
          fixed: false
        },
        {
          label: '优惠券分类',
          prop: 'coupon_from',
          width: 'auto',
          align: 'center',
          fixed: false
        },
        {
          label: '使用条件',
          prop: 'message',
          width: 'auto',
          align: 'center',
          fixed: false
        }
      ],
      setIntegralDiaData: [],
      multipleSelection1: [],
      multipleSelection2: []
    };
  },
  filters: {
    dateFormat(val) {
      return !val ? '' : dayjs.unix(val).format('YYYY-MM-DD');
    },
    dateTimeFormat(val) {
      return !val ? '' : dayjs.unix(val).format('YYYY-MM-DD HH:mm');
    },
    couponFromText(val) {
      switch (val) {
        case 1:
          return '诊疗优惠劵';
        case 2:
          return '商城优惠券';
      }
    },
    totalText(val) {
      switch (val) {
        case -1:
          return '无限';
        default:
          return val;
      }
    }
  },
  computed: {
    module_id_array() {
      return this.$store.state.userInfo.userInfo.module_id_array;
    }
  },
  created() {
    this.getList();
  },
  methods: {
    getList() {
      let params = Object.assign({}, this.pagination, this.searchForm);
      this.tableLoading = true;
      integralmanage.getExchangeCouponList(params).then((res) => {
        let { code, data } = res;
        if (code == 0) {
          this.integralExchangeData = data.list;
          this.totalNum = data.total;
          this.tableLoading = false;
        }
      });
    },
    seachEnterFun(e) {
      var keyCode = window.event ? e.keyCode : e.which;
      if (keyCode == 13) {
        this.getList();
      }
    },
    // 添加
    addBtn() {
      this.couponDiaForm.coupon_from =
        this.searchForm.coupon_from != 0 ? this.searchForm.coupon_from : 1;
      this.couponDia = true;
      this.getClickOrShopCoupon();
    },
    // 删除
    delBtn(rule_id) {
      this.$confirm('删除后将不可兑换，确认删除当前优惠券吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消'
      })
        .then(() => {
          integralmanage.deleteExchangeCoupon({ rule_id }).then((res) => {
            let { code } = res;
            if (code === 0) {
              this.$message.success('删除成功');
              this.getList();
            }
          });
        })
        .catch(() => {});
    },
    // 排序
    updateSort(rule_id, op_type) {
      integralmanage.sortExchangeCoupon({ rule_id, op_type }).then((res) => {
        let { code } = res;
        if (code == 0) {
          this.$message.success('排序成功');
          this.getList();
        }
      });
    },
    restBtn() {
      for (let key in this.searchForm) {
        if (key == 'coupon_from') {
          this.searchForm[key] = 0;
        } else {
          this.searchForm[key] = '';
        }
      }
      this.getList();
    },
    // 选择优惠券--Dia //
    // 获取优惠券列表
    getClickOrShopCoupon() {
      let params = Object.assign(
        {
          path_from: 1 // 1 积分 2 养生卡
        },
        this.couponDiaPagination,
        this.couponDiaForm
      );
      this.couponDiaTableLoading = true;
      common.getClickOrShopCoupon(params).then((res) => {
        let { code, data } = res;
        if (code == 0) {
          this.couponTableDiaData = data.list;
          this.couponDiaTotalNum = data.total;
          this.couponDiaTableLoading = false;
        }
      });
    },
    // 切换优惠券类型
    couponFromChange() {
      this.couponDiaPagination.page = 1;
      this.getClickOrShopCoupon();
    },
    // 选择诊疗优惠券
    handleDiaSelectionChange(val) {
      this.multipleSelection1 = val;
    },
    // 选择商品优惠券
    handleDiaSelectionChange2(val) {
      this.multipleSelection2 = val;
    },
    confirmCoupon() {
      if (!this.multipleSelection1.length && !this.multipleSelection2.length) {
        this.$message.warning('请选择优惠券');
        return;
      }
      this.setIntegralDiaData = _.uniqBy(
        [...this.multipleSelection1, ...this.multipleSelection2],
        'coupon_data_id'
      );
      this.couponDia = false;
      this.setIntegralDia = true;
      this.$forceUpdate();
    },
    closeCoupon() {
      this.setIntegralDiaData = [];
      this.multipleSelection1 = [];
      this.multipleSelection2 = [];
      this.couponDia = false;
    },
    // 选择优惠券--Dia--end //
    // 设置兑换积分数--Dia //
    setIntegralBlur(row) {
      console.log(row);
    },
    closeSet() {
      this.multipleSelection1 = [];
      this.multipleSelection2 = [];
      this.setIntegralDia = false;
    },
    confirmsetIntegral() {
      let coupon_list = this.setIntegralDiaData.map((item) => {
        return _.pick(item, ['coupon_data_id', 'coupon_from', 'integral']);
      });
      let isEmpty = coupon_list.some((item) => !item.integral);
      if (isEmpty) {
        this.$message.warning('请填写完整');
        return;
      }

      integralmanage.addExchangeCoupon({ coupon_list }).then((res) => {
        let { code } = res;
        if (code === 0) {
          this.$message.success('添加成功');
          this.closesetIntegral();
          this.getList();
        }
      });
    },
    closesetIntegral() {
      this.setIntegralDiaData = [];
      this.closeSet();
    }
    // 设置兑换积分数--Dia //
  }
};
</script>

<style lang="scss" scoped >
.container {
  box-sizing: border-box;
  background-color: #ffffff;
  min-height: calc(100vh - 140px);
}
.integralExchange {
  .top-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
  }
  .search-box {
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    margin-bottom: 10px;
    .item {
      height: 100%;
      display: flex;
      align-items: center;
      margin-bottom: 6px;
      span {
        display: inline-block;
        margin-right: 4px;
        text-align: right;
        white-space: nowrap;
        box-sizing: border-box;
      }
    }
    .item-content {
      // width: 100%;
      .el-date-editor {
        width: 100%;
      }
    }
  }
}
</style>
<style lang="scss" >
.dia-coupon {
  .search_box {
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    .item {
      height: 100%;
      display: flex;
      align-items: center;
      margin-bottom: 10px;
      span {
        display: inline-block;
        width: 110px;
        margin-right: 10px;
        text-align: right;
        white-space: nowrap;
      }
    }
    .input_width {
      width: 160px;
    }
  }
}
</style>